import { Lock } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Locked = () => {
    const { t } = useTranslation('common');

    return (
        <div className="flex h-full w-full items-center justify-center bg-white">
            <div className="justify-center text-center">
                <Lock className="mx-auto size-16 text-gray-500" strokeWidth={1} />
                <h3 className="mt-2 text-base font-medium text-neutral-900">
                    {t('common:pages.accessRestricted.title')}
                </h3>
                <p className="mt-1 text-base font-medium text-neutral-500">
                    {t('common:pages.accessRestricted.description')}
                </p>
            </div>
        </div>
    );
};

export default Locked;
